export default __webpack_public_path__ + "static/media/548.a9487fc4.jpg";